import { BoelsGenericState } from '@boels/models';
import { createReducer, on } from '@ngrx/store';
import {
  setActiveCategoryAction,
  setActiveCategoryListingPageAction,
} from '../actions/categories.action';

export interface CategoriesState extends BoelsGenericState {
  active?: string;
  activeListingPage?:
    | { itemCategory: string; itemCategory2: string }
    | Record<string, never>;
}

export const categoriesInitialState: CategoriesState = {
  active: undefined,
  loading: false,
  success: false,
  error: false,
};

export const reducer = createReducer(
  categoriesInitialState,
  on(setActiveCategoryAction, (state, { categoryId }) => ({
    ...state,
    active: categoryId,
    loading: true,
    success: false,
    error: false,
  })),
  on(setActiveCategoryListingPageAction, (state, categoryId) => ({
    ...state,
    activeListingPage: categoryId,
    loading: true,
    success: false,
    error: false,
  })),
);
